module.exports = __webpack_public_path__ + "img/2perform_Logo_weiss_RGB.1e9643f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2perform_Logo_weiss_RGB.png
// module id = CRg9
// module chunks = 0